import { createAction, props } from '@ngrx/store';

export const loadFeatureFlags = createAction('[FeatureFlags] Load');

export const loadFeatureFlagsSuccess = createAction(
  '[FeatureFlags] Load Success',
  props<{ flags: Record<string, boolean> }>(),
);

export const loadFeatureFlagsFailure = createAction(
  '[FeatureFlags] Load Failure',
  props<{ error: string }>(),
);

export const clearFeatureFlags = createAction('[FeatureFlags] Clear');
